import React from 'react';
import './styles.scss';

interface SubpageBlueProps {
    title: string;
    className?: string;
    headerChildren: JSX.Element;
    children: JSX.Element;
}

export default function SubpageBlue({ title, className, headerChildren, children }: SubpageBlueProps): JSX.Element {
    return (
        <div className={`as-subpage blue ${className}`}>
            <section>
                <article>
                    <div className='header-blue-subpage'>
                        <h2>{title}</h2>
                        <div className='line' />
                        {headerChildren}
                    </div>
                    <div className='body-blue-subpage'>{children}</div>
                </article>
            </section>
        </div>
    );
}
